export const TipoSelect = ({ name, value, onChange }) => {
    return (
        <select name={name} value={value} onChange={onChange}>
            <option value='R'>Resumen</option>
            <option value='D'>Detalle</option>
        </select>
    )
}